import api from './auth';

// 获取管理员列表
export const getAdmins = () => {
  return api.get('/admin');
};

// 获取单个管理员详情
export const getAdmin = (id: number) => {
  return api.get(`/admin/${id}`);
};

// 创建管理员
export const createAdmin = (data: any) => {
  return api.post('/admin', data);
};

// 更新管理员
export const updateAdmin = (id: number, data: any) => {
  return api.put(`/admin/${id}`, data);
};

// 删除管理员
export const deleteAdmin = (id: number) => {
  return api.delete(`/admin/${id}`);
};

// 重置管理员密码
export const resetPassword = (id: number, password: string) => {
  return api.post(`/admin/${id}/reset-password`, { password });
};

// 更新用户频道（仅 admin）
export const updateUserChannel = (userId: number, data: { channelName: string }) => {
  return api.patch(`/admin/${userId}/channel`, data);
};
